
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.629 12.688a.75.75 0 01-1.258-.817l1.258.817zm6.097-5.877a2.34 2.34 0 10-2.354 2.34h.024a2.34 2.34 0 002.33-2.34zm3.119-3.834a3.843 3.843 0 013.539 3.108 3.842 3.842 0 01-1.25 3.622 5.978 5.978 0 012.494 2.164.75.75 0 11-1.257.817 4.477 4.477 0 00-3.756-2.036.75.75 0 010-1.5 2.343 2.343 0 001.889-3.72 2.341 2.341 0 00-2.759-.795l-.277-.697-.279-.696c.526-.21 1.091-.3 1.656-.267zm-1.1 1.66a.75.75 0 01-.556-1.393l.556 1.393zm-.52 2.174a3.83 3.83 0 01-1.32 2.897 5.982 5.982 0 012.493 2.163.75.75 0 01-1.257.817 4.48 4.48 0 00-3.74-2.037l-.016.001h-.018a4.48 4.48 0 00-3.738 2.036L1 12.28l-.629-.408a5.982 5.982 0 012.492-2.163 3.84 3.84 0 116.362-2.896z","fill":"#4A4A4A"}})])
          )
        }
      }
    